/**
 *  生成不重复的随机数
 * */
export function generateMathRandom(val, key = 'id') {
  let date = parseInt((Math.random() * 9 + 1) * 100000);
  if (val.findIndex(val => { return val[key] === date }) !== -1) {
    return generateMathRandom(val);
  } else {
    return date;
  }
}

/**
 * 生成特定的控件格式
 * source 数据来源  xLink 横向连接  allMerge 追加合并  filter 数据筛选  pool 分组汇总  fieldSys 字段设置  output 数据呈现
 * */
export function generateDate(val, event) {
  console.log('生成数据', val, event)
  const type = {
    source: '数据来源',
    xLink: '横向连接',
    allMerge: '追加合并',
    filter: '数据筛选',
    pool: '分组汇总',
    fieldSys: '字段设置',
    output: '数据呈现',
    orders: '数据排序'
  };
  const date = {
    top: event.layerY - 18,
    left: event.layerX - 74,
    name: type[val],
    type: val,
    dataconfig:{},//这个是后台要用得配置信息
    datas:[],//这个是我们要用得数据
    parentid:[],//这个是父级得id，例如
    button: {
      right: true,
      left: true,
    },
  };
  if (val === 'source') date.button = { right: true, left: false };
  if (val === 'output') date.button = { right: false, left: true };
  return date;
}

/**
 * 生成字段设置需要的 dataconfig
 * **/
export function fieldSysGenerate(data) {
  if (!data) return [];
  const arr = []
  data.some(val => {
    let date = {
      name: val.name1,
      alias: val.name,
      formula: val.condition ? val.condition : ''
    };
    // 如果是字段设置的话 覆盖他
    if (val.isFormula) {
      let str = JSON.parse(JSON.stringify(val.condition));
      let strIndex = str.indexOf('(');
      if (strIndex !== -1) {
        date.formula = str.substr(0, strIndex);
        str = str.substring(0, str.length - 1);
        date.name = (val.conditionNode ? '' : '$') + str.substr((Number(strIndex) + 1), (Number(str.length) - 1));
      }
    }
    arr.push(date);
  })
}

/**
 * 连线生成数据
 * */
export function linkSvgStater(event, list, path, id) {
  console.log('链接数据 起始节点', event, list, path, id)
  const drageBlock = document.getElementById(id).getBoundingClientRect();
  const eventBlock = event.target.getBoundingClientRect();
  const date = {
    path: path,
    id: 'svg' + list.id,
    start: {
      id: list.id,
      x: eventBlock.left - drageBlock.left,
      y: eventBlock.top - drageBlock.top
    }
  };
  console.log('返回的初始结构', date, list)
  return date;
}

/**
 * 如需新增控件，需要在下面增加
 * */
export function navdata() {
  let nav = [{
    name: '输入',
    children: [
      {
        name: '数据来源',
        icon: 'icon-shujufuwu',
        drageName: 'source'
      }
    ]
  },
  {
    name: '多表合并',
    children: [
      {
        name: '横向连接',
        icon: 'icon-shouye-zhuanhuanxuexiao-',
        drageName: 'xLink'
      },
      {
        name: '追加合并',
        icon: 'icon-wenjianbeifen',
        drageName: 'allMerge'
      },
    ]
  },
  {
    name: '数据处理',
    children: [
      {
        name: '数据筛选',
        icon: 'icon-shaixuan',
        drageName: 'filter'
      },
      {
        name: '分组汇总',
        icon: 'icon-xiajibumen',
        drageName: 'pool'
      },
      {
        name: '字段设置',
        icon: 'icon-shouye-shezhi-',
        drageName: 'fieldSys'
      },
      {
        name: '数据排序',
        icon: 'WSicon-paixu',
        drageName: 'orders'
      },
    ]
  },
  {
    name: '输出',
    children: [
      {
        name: '数据呈现',
        icon: 'icon-shangchuantouxiang',
        drageName: 'output'
      },
    ]
  }]
  return nav
}


/**
 * 仪表盘设置数据
 * */
export function instrumentData() {
  let nav = [{
    name: '+可视化模型',
    children: [
      {
        name: '明细表',
        icon: 'icon-shujufuwu',
        drageName: 'detailed'
      },
      {
        name: '汇总表',
        icon: 'icon-shujufuwu',
        drageName: 'summary'
      },
      {
        name: '可视化图形',
        icon: 'icon-shujufuwu',
        drageName: 'indicatorsBread'
      },
/*
      {
        name: '统计图片',
        icon: 'icon-shujufuwu',
        drageName: 'picture'
      }
*/
    ]
  },
  {
    name: '+文本说明',
    children: [
      {
        name: '文本组件',
        icon: 'icon-shouye-zhuanhuanxuexiao-',
        drageName: 'text'
      }
    ]
  },
  {
    name: '+筛选器',
    children: [
      {
        name: '筛选组件',
        icon: 'icon-shaixuan',
        drageName: 'Sizer'
      }
    ]
  },
  // {
  //   name: '+消息提醒',
  //   children: [
  //     {
  //       name: '定时提醒',
  //       icon: 'icon-shangchuantouxiang',
  //       drageName: 'message'
  //     },
  //   ]
  // }
]
  return nav
}

/**
 * 控件名称和图片数据
 * */
export function iconFunRet(val) {
  let data = navdata()
  let headline = {}
  data.forEach(e => {
    if(e.children&&e.children.length>0){
     e.children.forEach(el => {
       headline[el.drageName] = el
      });
    }
  });
  if(val){
    return headline[val]
  }else{
    return headline
  }
}

/**
 * 是否存在 drageBlck
 * */
export function isDrageBlock(event) {
  if (event.target.className &&
    typeof event.target.className === 'string' &&
    (event.target.className.indexOf('drageBlock')) !== -1) return event.target;
  if (event.target.offsetParent &&
      event.target.offsetParent.className &&
      typeof event.target.offsetParent.className === 'string' &&
      (event.target.offsetParent.className).indexOf('drageBlock') !== -1) return event.target.offsetParent;
  return null;
}

/**
 * 处理节点变动之后的全删
 * */
export function delDomArr(id, dom, svg) {
  console.log('开始节点处理', id, dom, svg)
  let doms = reset(id, dom);
  // 处理svg 线路
  return findEndId(id, doms, svg);
}

/**
 * 重置节点信息
 * */
export function reset(id, dom) {
  console.log('重置的domId', id)
  let domIndex = dom.findIndex(val => { return Number(val.id) === Number(id) });
  if (domIndex !== -1) {
    // 重置配置信息
    dom[domIndex].dataconfig = {};   //这个是后台要用得配置信息
    dom[domIndex].datas = [];   //这个是我们要用得数据
    dom[domIndex].parentid = [];    //这个是父级得id，例如
  }
  return dom;
}

/**
 * 根据线路删除当前及之后的
 * */
export function findEndId(id, dom, svg) {
  let index = svg.findIndex(val => { return Number(val.start.id) === Number(id) });
  if (index !== -1) {
    let doms = reset(svg[index].end.id, dom);
    doms = findEndId(svg[index].end.id, doms, svg);
    return doms;
  }
  return dom;
}

/**
 * 检测节点是否都进行了配置
 * */
export function findCongif (val) {
  for (let i = 0; i < val.length; i++) {
    if (JSON.stringify(val[i].dataconfig) === '{}') {
      if (val[i].type === 'source') {
        return '当前节点无数据源';
      } else {
        return '当前节点未完成工序配置';
      }
    }
  }
  return false;
}

/**
 * 数据源不能没有连接
 * */
export function sourceNoLink(drage, svg) {
  if (svg.length === 0 || drage.length === 0) return false;
  for (let i = 0; i < drage.length; i++) {
    if (drage[i].type === 'source') {
      let index = svg.findIndex(val => { return Number(val.start.id) === Number(drage[i].id) });
      if (index === -1) return false;
    }
  }
  return true;
}

/**
 * 表单 showconfig 数据合并
 */
export function getShowconfig (config) {
  let list = [
    { name: '申请人', type: 'relation-user', title: '申请人' },
    { name: '单号', type: 'text', title: '单号' },
    { name: '状态', type: 'status', title: '状态' },
    { name: '提交时间', type: 'date', title: '提交时间' },
    { name: '归档状态', type: 'status', title: '归档状态' },
    // { name: '存证状态', type: 'cochain', title: '存证状态' }
  ]
  if (!config) return list
  try {
    config = JSON.parse(config)
  } catch (e) { console.log(e) }
  for (let i = 0; i < list.length; i++) {
    if (config[list[i].title] || config[list[i].title] === 0) list[i].name = config[list[i].title]
  }
  return list
}